export function getHeaderTranslationLiterals(t: any): any {
    return {
        navigation: {
            brand: { 
                id: "brand", 
                name: t("nav.brand"), 
                href: "/" },
            about: {
                id: "aboutDoco",
                name:  t("nav.aboutDoco"),
                href: t("url.aboutDoco"),
                children: [
                    { id: "howItWorks", name: t("nav.howItWorks"), href: t("url.howDoesItWork") },
                    { id: "companies", name: t("nav.companies"), href: t("url.companies") },
                    { id: "blog", name:t("nav.blog"), href: t("url.blog") },
                ]
            },
            allLinks: [
                { id: "travel", name: t("nav.travel"), href: '/plan' },
                { id: "toPlanTrain", name:  t("nav.toPlanTrain"), href: "/planTrain" },
                { id: "myTrips", name: t("nav.myTrips"), href: "/my-trips" },
                { id: "help", name: t("nav.help"), href: t("url.help") }
            ]
        },
        literals: {
            buttonLeft: { id: 'leftButton', name: t("literal.buttonLeft"), href: '/left-button' },
            maintext: t('literal.maintext'),
            buttonRight: { id: 'rightButton', name: t("literal.buttonRight"), href: '/' },
            loginText: t("literal.login"),
            pathInternalNavigation: {
                myProfile: "/my-profile",
                login: "/login"
            },
            download: t("literal.download"),
            modalLanguage: {
                title: t("literal.modalLanguage.title"),
            },
            languages: [
                {
                    code: "spa",
                    text: "Castellano",
                    desc: "¡Hola! :) ¡Qué ganas de viajar contigo!",
                    disabled: false,
                    hidden: false
                },
                {
                    code: "cat",
                    text: "Catalá",
                    desc: "Hola! :) Ens encanta viatjar amb tu!",
                    disabled: true,
                    hidden: false
                },
                {
                    code: "gal",
                    text: "Galego",
                    desc: "Ola! :) Onde imos? ",
                    disabled: true,
                    hidden: false
                },
                {
                    code: "val",
                    text: "Valenciá",
                    desc: "Hola! :) Encantats de viatjar amb tu!",
                    disabled: true,
                    hidden: true
                },
                {
                    code: "eus",
                    text: "Euskera",
                    desc: "Kaixo! :) Nora goaz? ",
                    disabled: true,
                    hidden: false
                },
                {
                    code: "eng",
                    text: "English",
                    desc: "Hello! :) Cannot wait to travel with you!",
                    disabled: false,
                    hidden: false
                },
                {
                    code: "fra",
                    text: "Français",
                    desc: "Salut! :) Où allons nous? ",
                    disabled: true,
                    hidden: false
                }
            ],
            currentCode: "spa",
            
        }
    }
}